import styled, { css } from 'styled-components';
import { colors as colors99dUi } from '@99designs/emu/settings';
import { colors } from '../../lib/styles';

const StyledLink = styled.a<{
    linkColor: string;
    size?: string;
    linkFontFamily: string;
}>(({ linkColor, size = 'inherit', linkFontFamily }) => {
    return css`
        font-size: ${size};
        font-family: ${linkFontFamily};
        text-decoration: none !important;
        color: ${linkColor} !important;
        transition: border-color 0.15s ease-out;
        border-color: ${linkColor !== 'currentColor'
            ? colors99dUi.withAlpha(linkColor, 0.2)
            : colors99dUi.withAlpha(colors.grey800, 0.2)};
        border-bottom-width: 2px;
        border-bottom-style: solid;

        &:link,
        &:visited {
            border-color: ${linkColor !== 'currentColor'
                ? colors99dUi.withAlpha(linkColor, 0.2)
                : colors99dUi.withAlpha(colors.grey800, 0.2)};
        }

        &:hover,
        &:focus {
            border-color: ${linkColor !== 'currentColor'
                ? colors99dUi.withAlpha(linkColor, 0.4)
                : 'currentColor'};
        }

        &:active {
            border-color: transparent;
        }
    `;
});

export const StyledCTALink = styled(StyledLink as any)(({ linkColor }) => {
    return css`
        border-color: ${linkColor !== 'currentColor'
            ? colors99dUi.withAlpha(linkColor, 0)
            : 'transparent'};
        border-bottom-width: 2px;

        &:link,
        &:visited {
            border-color: ${linkColor !== 'currentColor'
                ? colors99dUi.withAlpha(linkColor, 0)
                : 'transparent'};
        }

        &:hover,
        &:focus {
            border-color: ${linkColor !== 'currentColor' ? linkColor : 'currentColor'};
        }
    `;
});

export const StyledHeadingLink = styled(StyledCTALink as any)<{
    linkColor?: string;
    isActive?: boolean;
}>(({ linkColor, isActive }) =>
    isActive
        ? css`
              border-bottom-width: 2px;

              &,
              &:link {
                  border-color: ${linkColor};
              }
          `
        : css`
              border-bottom-width: 2px;

              &:focus {
                  border-color: transparent;
              }
          `
);

export default StyledLink;
